<script setup>
import VDevider from "@/Shared/VDevider.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VTextareaShowWithLabel from "../../Form/Survey/VTextareaShowWithLabel.vue";

import { useForm } from "@inertiajs/vue3";

const props = defineProps({
    additional: Object,
});

const { surveyFields, answers } = props.additional;

const form = useForm({
    feedbacks: answers?.feedbacks,
});

const emits = defineEmits("onNext");

const handleClickNext = () => {
    emits("onNext", form.data());
};
</script>

<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <VTextareaShowWithLabel
                        elId="feedbacks"
                        v-model:value="form.feedbacks"
                        :label="surveyFields['feedbacks']?.name"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
